/**
 * Scripts in this file will be added to the site via theme.liquid layout (found inside the dist/layout directory) using the asset-router-js.liquid snippet )
 * for more info on theme layouts see: https://shopify.dev/tutorials/develop-theme-layouts
 *
 * Compiles to ./assets/scripts/layout.theme.js
 */

/* eslint-disable no-unused-vars */

/* **** Note **** strictly coupled template scripts should not be imported here. They are
are added conditionallly via the asset-router-js.liquid file. This helps keep the code more lean  */

// Import ES6 modules (recommended)
// import 'lazysizes/plugins/object-fit/ls.object-fit';
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// import 'lazysizes/plugins/rias/ls.rias';
// import 'lazysizes/plugins/bgset/ls.bgset';
// import 'lazysizes';
// import 'lazysizes/plugins/respimg/ls.respimg';
// import 'what-input';

// import { focusHash, bindInPageLinks } from '@shopify/theme-a11y';
// import {cookiesEnabled} from '@shopify/theme-cart';

// import 'UTILS/responsive-background-images';

// import 'COMPONENTS/mediaCard';
// import 'ACCESSIBILITY/focusFormErrors';
// import headerController from 'COMPONENTS/headerController';
// import navController from 'COMPONENTS/navController';

// Initialize Header & Nav Controllers
// headerController.init();
// navController.init();

// Common a11y fixes
// focusHash();
// bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
// if (cookiesEnabled()) {
//   document.documentElement.className = document.documentElement.className.replace(
//     'supports-no-cookies',
//     'supports-cookies',
//   );
// }

import buttonController from 'COMPONENTS/buttonController';
import orderNowModal from 'COMPONENTS/orderNowModal';
import 'COMPONENTS/quantityComponent';

buttonController.init();
orderNowModal.init();
